import React, { useEffect, useRef, useState } from "react";
import {
  Input,
  Form,
  Select,
  Button,
  Tag,
  Descriptions,
  AutoComplete,
  message
} from "antd";
import {
  addDurationTotal,
  addDurationMeasure,
  addFrequency,
} from "../store/slice/Medicine-slice";
import { useSelector, useDispatch } from "react-redux";
import "./Styles/FormMedicine.scss";
import OtpInput from "react-otp-input";
import Validators from "Common/Validators";

function FormMedicine(props) {
  const med_form = useRef(null);
  const instruction_input = useRef(null);
  const dispatch = useDispatch();

const [form_action,setFormAction]=useState([]);
  const [options, setOptions] = useState([]);
  const [form, setForm] = useState();
  const [is_duplicate,setIsDuplicate]=useState(false)
  const [dosage, setDosage] = useState(props.medicine_array?.dosage);
  const [instructionListOptions, setInstructionListOptions] = useState([]);
  const [selectedTag, setSelectedTag] = useState();
  const [allow_search, setAllowSearch] = useState(true);
const [med_list,setMedList]=useState([])
  const onSelectForm = (val, i) => {
    setAllowSearch(false);
    setSelectedTag(i);
    setForm(val.form_name);
    setDosage(val.strength_dosage);
    props.onSelectForm(val);
  };


useEffect(()=>{
if(med_list.length==0){
  setMedList(props.update_medicine)
}else{
  setMedList([...med_list,props.update_medicine?.[0]])
}
   
},[props?.update_medicine])
useEffect(()=>{

  setMedList((med_list) => {
    let temp=med_list.filter((item, i) => item.medicine_id !== props.remove_medicine.medicine_id);
    return temp
  });
},[props.remove_medicine])
  useEffect(() => {
if(props?.column=="add"){
  setSelectedTag(null)
  setForm(null)
}

    if (props?.column == "edit") {
      if (props?.medicine_array?.form) {
        Object.values(props.medicine_array?.form_dosage).filter((i, j) => {
          if (i.form_name == props.medicine_array?.form)
            if (i.strength_dosage == props?.medicine_array?.dosage)
              setSelectedTag(j);
          setForm(props?.medicine_array?.form);
          setDosage(props?.medicine_array?.dosage);
        });
      }
    }

    if (props?.medicine_array?.intake) {
      let options = props.medicine_array.intake.map((item) => {
        return {
          label: item.intake_name,
          value: item.intake_name,
        };
      });
      setInstructionListOptions(options);
    }

    med_form?.current?.setFieldsValue({
      route:
        props?.medicine_array?.route?.[0]?.route_name ||
        props?.medicine_array?.route,
      instruction:
        props?.medicine_array?.instruction ||
        props?.medicine_array?.intake?.[0]?.intake_name,
      adjuvant:
        props?.medicine_array?.adjuvant?.[0]?.adjuvant_name ||
        props?.medicine_array?.adjuvant,
      frequency: {
        1: props.medicine_array?.frequency?.split("-")?.[0] || props?.medicine_array?.route?.[0]?.morning,
        2: props.medicine_array?.frequency?.split("-")?.[1] || props?.medicine_array?.route?.[0]?.noon,
        3: props.medicine_array?.frequency?.split("-")?.[2] || props?.medicine_array?.route?.[0]?.evening,
        4: props.medicine_array?.frequency?.split("-")?.[3] || props?.medicine_array?.route?.[0]?.night,
        measure: props.medicine_array?.frequency_measure || props?.medicine_array?.route?.[0]?.frequency_measurement        ,
      },
      duration: {
        total: props?.medicine_array?.duration?.split(" ")[0] || props?.medicine_array?.route?.[0]?.duration.split(" ")?.[0],
        measure: props?.medicine_array?.duration?.split(" ")[1] || props?.medicine_array?.route?.[0]?.duration.split(" ")?.[1],
      },
    });
  }, [props.medicine_array]);
  const handleCancel = () => {
    med_form.current.resetFields();
    setForm(null);
    setSelectedTag(null)
    setDosage(null)
    if (props.on_edit) {
      props.onClearMedicine();
    } else {
      props.onClearSearch();
    }
  };

  const onSubmitForm = (val) => {
    
    let temp_frequency = Object.values(val.frequency);
    if (typeof val.instruction == "string") {
      val["instruction"] = val?.instruction.trim();
    }
    val["medicine_id"] = props?.selectedValue;
    val["brand"] = props.medicine_array?.brand;
    val["medicine"] = props.medicine_array?.medicine;
    val["form"] = form;
    val["dosage"] = dosage;
    // if (props.prescription_type == "ayurveda") {
    val["frequency_measure"] = temp_frequency[4];
    if (temp_frequency[4]) {
      val["frequency"] =
        temp_frequency[0] +
        temp_frequency[4] +
        "-" +
        temp_frequency[1] +
        temp_frequency[4] +
        "-" +
        temp_frequency[2] +
        temp_frequency[4] +
        "-" +
        temp_frequency[3] +
        temp_frequency[4];
    } else {
      val["frequency"] =
        temp_frequency[0] +
        "-" +
        temp_frequency[1] +
        "-" +
        temp_frequency[2] +
        "-" +
        temp_frequency[3];
    }
    // } else {
    //   val["frequency"] = val.frequency;
    // }
    val["form_id"] = props.medicine_array.form_dosage.form_id;
    val["brand_id"] = props.medicine_array.brand_id;
    val["drug_id"] = props.medicine_array.drug_id;
    // setForm(undefined);
     if(checkDuplicate(val)==true && form_action=="add"){
      message.error("Medicine already exists in the Table!", ErrorDuration) 
     }else{
    props.onUpdateMedicine(val);
    med_form.current.resetFields();
    setSelectedTag(undefined);
    setForm("");
    setDosage("");
  }
  };
  const checkDuplicate=(data)=>{
    for (let x in med_list){  
      if( med_list[x]["medicine_id"]==data?.medicine_id &&
      med_list[x]["brand_id"]==data?.brand_id &&
    med_list[x]["form"]==data?.form &&
    med_list[x]["dosage"]==data?.dosage
      ){  
   return true
    }
  
  } 
   }
  const list1Options = props?.medicine_array?.intake;
  // const { list1Value } = newOption;

  const list1SelectOptions = list1Options?.map((o) => (
    <Option key={o.intake_id} label={o.intake_name} value={o.intake_name}>
      {o.intake_name}
    </Option>
  ));

  const handleInstructionSearch = (value) => {
    let options = props?.medicine_array?.intake
      ?.filter((item) =>
        item.intake_name?.toLowerCase().includes(value?.toLowerCase())
      )
      .map((item) => {
        return {
          label: item.intake_name,
          value: item.intake_name,
        };
      });
    setInstructionListOptions(options);
  };
  return (
    <div className="App">
      <div>
        {props?.medicine_array?.medicine ? (
          <>
            <Descriptions
              bordered
              size="small"
              column={2}
              labelStyle={{ width: "20%" }}
              contentStyle={{ width: "30%" }}
            >
              <Descriptions.Item label="Medicine">
                {props?.medicine_array?.medicine}
              </Descriptions.Item>
              <Descriptions.Item label="Brand">
                {props?.medicine_array?.brand || "-"}
              </Descriptions.Item>
            </Descriptions>
          </>
        ) : null}
      </div>
      <Form
        name=" medicine_form"
        ref={med_form}
        labelCol={{ xs: 24, md: 5, lg: 5 }}
        labelWrap={{ xs: 24 ,md: 4}}
        wrapperCol={{ xs: 24, md: 10, lg:10}}
        onFinish={(data) => {
          onSubmitForm(data);
        }}
        className="med-form-container"
        labelAlign={"left"}
        colon={false}
      >
        {props?.medicine_array?.medicine ? (
          <>
            <Form.Item label={"Form(Dosage)"} 
                      wrapperCol={{ span: 16 }}
            >
              <div className="tag-grp">
                {Object.values(props?.available_forms || []).map((item, i) => {
                  return (
                    <Tag
                      onClick={() => onSelectForm(item, i)}
                      className={selectedTag == i ? "selectedTag" : null}
                      style={{
                        margin: "5px 0",
                        cursor: "pointer",
                        borderRadius: "25px",
                        fontSize: "14px",
                        fontWeight: "500",
                        textAlign: "center",
                      }}
                    >
                      {item?.form_name}
                      {item?.strength_dosage
                        ? "(" + item?.strength_dosage + ")"
                        : null}
                    </Tag>
                  );
                })}
              </div>
            </Form.Item>
          </>
        ) : null}

        {props?.medicine_array?.medicine && form ? (
          <>
            <Form.Item
              name={["route"]}
              label={"Route"}
              rules={[
                {
                  required: true,
                  message: "Please select the route.",
                },
              ]}
              // Col={{ span: 6 }}
            >
              {props?.type == "add-new-drug" ? (
                <Input style={{ width: "200px" }}/>
              ) : (
                <Select
                style={{ width: "200px" }}
                  value={
                    form ? form : props?.medicine_array?.route?.[0]?.route_name
                  }
                  onChange={(option, val) => setForm(val?.label)}
                  placeholder={"Select route"}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {Object.values(props?.medicine_array?.route || []).map(
                    (i) => {
                      return (
                        <Select.Option  style={{ width: "200px" }} value={i.route_id} label={i.route_name}>
                          {i.route_name}
                        </Select.Option>
                      );
                    }
                  )}
                </Select>
              )}
            </Form.Item>

            {props?.medicine_array?.type && props.medicine_array.type != "allopathy" ? (
              <Form.Item name={["adjuvant"]} label={"Adjuvant"} 
              className="adjuvant-select-field"
              rules={[
                {
                  required: true,
                  message: "Please select the adjuvant.",
                },
              ]}>
                {props.type == "add-new-drug" ? (
                  <Select options={options} />
                ) : (
                  <Select placeholder={"Select adjuvant"}>
                    {Object.values(props?.medicine_array?.adjuvant || []).map(
                      (option, i) => {
                        return (
                          <Select.Option
                            key={i}
                            value={option.adjuvant_name}
                            label={option.adjuvant_name}
                          >
                            {option.adjuvant_name}
                          </Select.Option>
                        );
                      }
                    )}
                  </Select>
                )}
              </Form.Item>
            ) : null}

            {/* {props.prescription_type == "ayurveda" ? ( */}
            <Form.Item
              required={true}
              name={["frequency"]}
              label={"Frequency"}
              rules={[
                {
                  required: true,
                  message: "Please fill the frequency.",
                },
                    Validators.checkDecimalWithZeroFormMedicine({type:props.prescription_type}),
              ]}
              validateTrigger={["onChange", "onBlur"]}
            >
              <Input.Group style={{ display: "flex" }} compact>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                    // Validators.checkDecimalWithZero,
                  ]}
                  name={["frequency", "1"]}
                  noStyle
                >
                  <Input
                    style={{
                      width: "20%",
                    }}
                    placeholder="Morning"
                    {...({maxLength: props?.medicine_array?.type == "allopathy" ? 1 : 4})}
                  />
                </Form.Item>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 4px",
                  }}
                >
                  -
                </span>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                    // Validators.checkDecimalWithZero,
                  ]}
                  name={["frequency", "2"]}
                  noStyle
                >
                  <Input
                    style={{
                      width: "20%",
                    }}
                    placeholder="Noon"
                    {...({maxLength: props?.medicine_array?.type == "allopathy" ? 1 : 4})}
                  />
                </Form.Item>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 4px",
                  }}
                >
                  -
                </span>
                <Form.Item
                  name={["frequency", "3"]}
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                    // Validators.checkDecimalWithZero,
                  ]}
                >
                  <Input
                    style={{
                      width: "20%",
                    }}
                    placeholder="Evening"
                    {...({maxLength: props?.medicine_array?.type == "allopathy" ? 1 : 4})}
                  />
                </Form.Item>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 4px",
                  }}
                >
                  -
                </span>
                <Form.Item
                  name={["frequency", "4"]}
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                    // Validators.checkDecimalWithZero,
                  ]}
                >
                  <Input
                    className="last-frequency"
                    style={{
                      width: "20%",
                    }}
                    placeholder="Night"
                    {...({maxLength: props?.medicine_array?.type == "allopathy" ? 1 : 4})}
                  />
                </Form.Item>
                {props.prescription_type != "allopathy" && (
                  <Form.Item
               
                    rules={[{ required: true, message: "" }]}
                    style={{
                      width: "25%",
                      height: "20px",
                      margin: "0px",
                      borderRadius: "0px",
                      marginLeft: "10px",
                    }}
                    name={["frequency", "measure"]}
                  >
                    <Select   disabled={props?.medicine_array?.form_dosage?.strength_dosage != "NA"?true:false}placeholder="mg/ml" style={{ borderRadius: "0px" }}>
                      <Select.Option value="ml">{"ml"}</Select.Option>
                      <Select.Option value="mg">{"mg"}</Select.Option>
                      <Select.Option value="gms">{"gms"}</Select.Option>
                    </Select>
                  </Form.Item>
                )}
              </Input.Group>
            </Form.Item>

            {/* ) : (
              <Form.Item
                name={["frequency"]}
                label={"Frequency"}
                rules={[
                  {
                    required: true,
                    message: "Please fill the frequency.",
                  },
                ]}
              >
                <OtpInput
                  onChange={(e) => dispatch(addFrequency(e))}
                  separator={<span>-</span>}
                  numInputs={4}
                  isInputNum={true}
                  className="otp-input"
                  inputStyle={{
                    margin: "0px 4px",
                    width: "28px",

                    border: "1px solid lightgray",
                    borderRadius: "5px",
                  }}
                />
              </Form.Item>
            )} */}

            <Form.Item
              required={true}
              labelCol={{ xs: 24, md: 5, lg: 5 }}
              wrapperCol={{ xs: 24, md: 8, lg:8}}
              label="Duration"
            >
              <Input.Group
                onChange={(e) => dispatch(addDuration(e))}
                //   disabled={this.props.prescriptionValue === 1 ? true : false} compact style={{ display: "flex" }}>
                style={{ display: "flex" }}
              >
                <Form.Item
                  name={["duration", "total"]}
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                    Validators.checkDecimalPrescription,
                  ]}
                  noStyle
                >
                  <Input placeholder="Type here"
                    onChange={(e) => dispatch(addDurationTotal(e.target.value))}
                    style={{ width: "35%" }}
                    maxLength={2}
                  />
                </Form.Item>
                <Form.Item
                  name={["duration", "measure"]}
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: "Please add duration.",
                    },
                  ]}
                >
                  <Select
                    className="duration-selector"
                    onChange={(e) => dispatch(addDurationMeasure(e))}
                    // disabled={this.props.prescriptionValue === 1 ? true : false}
                    style={{ width: "50%" }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    <Select.Option value="Day(s)">Day(s)</Select.Option>
                    <Select.Option value="Week(s)">Week(s)</Select.Option>
                    <Select.Option value="Month(s)">Month(s)</Select.Option>
                    <Select.Option value="Year(s)">Year(s)</Select.Option>
                    <Select.Option value="Tablet(s)">Tablet(s)</Select.Option>
                    <Select.Option value="PRN">PRN</Select.Option>
                  </Select>
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item />

            <Form.Item name={["instruction"]} label={"Instruction"}>
              <AutoComplete
                placeholder = "Type here"
                options={instructionListOptions}
                style={{
                  width: 420,
                }}
                optionFilterProp="children"
                onSearch={handleInstructionSearch}
              >
                <Input.TextArea />
              </AutoComplete>
            </Form.Item>
          </>
        ) : null}

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "20px",
            gap: "16px",
            alignItems: "baseline",
          }}
        >
          {props.medicine_array?.medicine && (
            <>
              {props.action === "add" && (
                <Button
                  className="confirm-btn"
                  disabled={!form}
                  htmlType="submit"
                  onClick={()=>setFormAction("add")}

                >
                  Add
                </Button>
              )}
              {props.action === "edit" && (
                <Button
                  className="confirm-btn"
                  disabled={!form}
                  htmlType="submit"
                  onClick={()=>setFormAction("update")}
                >
                  Update
                </Button>
              )}
              <Button
                className="cancel-btn"
                htmlType="reset"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </>
          )}
        </div>
      </Form>
    </div>
  );
}

export default FormMedicine;
